import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistsApi } from 'src/Services/API';
import { ChecklistDto, CreateChecklistDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreateChecklist = (
  options?: UseMutationOptions<ChecklistDto, unknown, CreateChecklistDto>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<ChecklistDto, unknown, CreateChecklistDto>(
    ['create-checklist', assetId],
    async checklist => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await checklistsApi.checklistsControllerCreate(assetId, checklist);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data: ChecklistDto, variables: CreateChecklistDto, context: unknown) => {
        trackEvent('Checklist', 'create', data.title);

        queryClient.invalidateQueries({ queryKey: ['fetch-checklists'] });
        queryClient.invalidateQueries({ queryKey: ['fetch-checklists-submissions'] });
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);

        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
